module.exports = __webpack_public_path__ + "img/pub_form2.04452835.png";